import React, { PureComponent } from 'react';
import { Store } from 'redux';
import { History } from 'history';
import { Provider as ReduxProvider } from 'react-redux';
import { CanvasContext } from 'react-three-fiber';
import { VRCanvas } from '@react-three/xr';

import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';

import PointRoute from './point-route';
import StoryRoute from './story-route';
// import PlaceRoute from './place-route';
// import ExperienceRoute from './experience-route';
// import ActionVideoRoute from './action-video-route';
import LiveTourExperienceRoute from './live-tour-experience-route';
import TestRoute from './test-route';
import { Cache } from 'three';
// import { isMacLike } from '../../common/device';
import Environment from '../../containers/xr/environment';
import GatewayService from '../../services/gateway-service';
import * as GatewayEvents from '../../common/constants/gateway-events';
import VRModeAdapter from '../../common/three/vr-mode-adapter';
import { isFunction } from 'lodash';
import { isMobile } from '../../common/device';
import SlideshowExperienceRoute from './slideshow-experience-route';
Cache.enabled = true;

type XRRootProps = {
  store: Store;
  history: History;
};

class XRRoot extends PureComponent<XRRootProps> {
  private vrModeAdapter?: VRModeAdapter;

  componentDidMount() {
    GatewayService.on(GatewayEvents.ACTION_TOGGLE_VR_MODE, this.handleVRModeChange);
  }

  componentWillUnmount() {
    GatewayService.off(GatewayEvents.ACTION_TOGGLE_VR_MODE, this.handleVRModeChange);
  }

  render() {
    const props = this.props;

    // <VRCanvas colorManagement={false} onCreated={this.handleCreate}>
    return (
      <VRCanvas colorManagement={false} concurrent pixelRatio={window.devicePixelRatio} onCreated={this.handleCreate}>
        <ReduxProvider store={props.store}>
          <ConnectedRouter history={props.history}>
            <Environment>
              <Switch>
                <Route path="/live/embed/:experienceId" exact component={LiveTourExperienceRoute} />
                <Route path="/:lang?/:university/story/:storyId" exact component={StoryRoute} />
                <Route path="/:lang?/:university/:pointId" exact component={PointRoute} />
                <Route path="/:lang/:lang2/:university/:pointId" exact component={PointRoute} />
                <Route component={TestRoute} />
              </Switch>
            </Environment>
          </ConnectedRouter>
        </ReduxProvider>
      </VRCanvas>
    );
  }

  handleCreate = async ({ gl }: CanvasContext) => {
    const { context } = gl;

    //@ts-ignore
    if (isMobile() && isFunction(context.makeXRCompatible)) {
      //@ts-ignore
      try {
        //@ts-ignore
        await context.makeXRCompatible();
      } catch (e) {
        console.error('error: makeXRCompatible: ', e);
      }
    }

    this.vrModeAdapter = new VRModeAdapter(gl);
  };

  handleVRModeChange = () => {
    if (this.vrModeAdapter) {
      this.vrModeAdapter.enterVR();
    }
  };
}

export default XRRoot;
